import { Component } from '@angular/core';

@Component({
  selector: 'zc-card-body',
  templateUrl: './card-body.component.html',
})
export class CardBodyComponent {}
